// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"y_sq h_jp h_fp h_fs h_fD h_dL h_t","menuItemSub":"y_sr h_dS h_fp h_fD","menuMainLink":"y_ss h_jq h_hk","menuLink":"y_st h_jq h_hk","Link":"y_rV x_rV x_q6 x_rr"};